import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Jackpot Settings</h4>
    </div>
  );
};
